import type { EventBus, SlackMessage } from './EventBus';

export interface JamieSystemOptions {
  bus: EventBus;
  messages: readonly SlackMessage[];
}

export class JamieSystem {
  private readonly dispatched = new Set<string>();

  constructor(private readonly opts: JamieSystemOptions) {}

  tick(fictionalMinutes: number): void {
    for (const message of this.opts.messages) {
      if (this.dispatched.has(message.id)) continue;
      if (fictionalMinutes < message.fictionalMinutes) continue;
      this.dispatched.add(message.id);
      this.opts.bus.emit('slack:message-received', { message });
    }
  }
}
